const enum LinkType {
    Header = 1,
    Footer = 2,
    SocialMedia = 3,
}

export default LinkType
